import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/pt-br'

interface DatePickerSingleProps {
    value?: Date | string | null
    onChange?: (value: Date | null) => void
    label?: string
    disabled?: boolean
}

export function DatePickerSingle({
    value,
    onChange,
    label,
    disabled = false,
}: DatePickerSingleProps) {
    const dayjsValue = value ? dayjs(value) : null

    const handleDateChange = (newDate: Dayjs | null) => {
        if (!onChange) return
        onChange(newDate?.toDate() || null)
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DatePicker
                label={label}
                value={dayjsValue}
                onChange={handleDateChange}
                disabled={disabled}
                slotProps={{
                    textField: {
                        variant: 'filled',
                        fullWidth: true,
                    },
                }}
            />
        </LocalizationProvider>
    )
}
